/* eslint-disable max-lines */
/* eslint-disable complexity */
import _ from 'lodash';
import commonFunctions from '../common-functions';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import VueSlider from 'vue-slider-component';

export default {
    name: 'ConciliationOperations',

    extends: commonFunctions,

    components: {
        VueSlider,
        DateRangePicker
    },

    /**
     * @override
     */
    props: {
        transferFilter:{
            type: String,
            required: false,
            default: ''
        },
        data: {
            type: Array,
            required: true
        },
        checks: {
            type: Boolean,
            required: false,
            default: true
        },
        icons: {
            type: Boolean,
            required: false,
            default: true
        },
        actions: {
            type: Boolean,
            required: false,
            default: false
        },
        details: {
            type: Boolean,
            required: false,
            default: true
        },
        filter: {
            type: Boolean | String,
            required: false,
            default: 'all'
        },
        sortable: {
            type: Boolean,
            required: false,
            default: false
        },
        editable: {
            type: Boolean,
            required: false,
            default: false
        },
        monitorType: {
            type: String,
            required: false,
            default: 'all'
        },
        sortBy: {
            type: String,
            required: false,
            default: 'transaction_date'
        },
        sortDesc: {
            type: Boolean,
            required: false,
            default: true
        },
        scrollTop: {
            type: Number,
            required: false,
            default: 50
        },
        settedFilters: {
            type: Object,
            required: false,
            default: () => ({})
        },
        maxAmount: {
            type: Number,
            required: false,
            default: 1000000
        },
        minAmount: {
            type: Number,
            required: false,
            default: 0
        }
    },

    data() {
        return {
            checksStatusEnabled: true,
            operationSelected: [],
            updateKey: 0,
            fields: [
                {
                    key: 'show_checks',
                    label: '',
                    thClass: this.checks ? '' : 'd-none',
                    tdClass: this.checks ? 'px-0 text-center' : 'd-none'
                },
                {
                    key: 'show_icons',
                    label: '',
                    thClass: this.icons ? '' : 'd-none',
                    tdClass: this.icons ? 'px-0 text-center d-flex align-items-center pt-3' : 'd-none'
                },
                {
                    key: 'request_date',
                    label: 'Fecha operación',
                    sortable: this.sortable,
                    thClass: 'fecha_op',
                    formatter: value => {
                        return this.$moment(new Date(value)).format('DD-MMM-YYYY');
                    }
                },
                {
                    key: 'key_product',
                    label: 'Producto',
                    sortable: this.sortable,
                    formatter: value => {
                        return this.$t(`operations.products.${value}`);
                    }
                },
                {
                    key: 'interveners',
                    label: 'Titular principal',
                    // sortable: this.sortable,
                    thClass: 'titular_principal',
                    formatter: value => {
                        const interveners = this.holders(value);
                        return interveners.length ? `${interveners[0].name} - ${interveners[0].item.document_id}` : '';
                    }
                },
                {
                    key: 'gross_amount',
                    label: 'Cantidad',
                    sortable: this.sortable,
                    thClass: 'text-right',
                    tdClass: 'text-right color-brand',
                    formatter: value => {
                        return value ? `${this.$options.filters.yuriDecimals(value, 2)} €` : 'N/C';
                    }
                },
                {
                    key: 'details',
                    label: '',
                    thClass: this.details ? '' : 'd-none',
                    tdClass: this.details ? '' : 'd-none'
                },
                {
                    key: 'actions',
                    label: '',
                    thClass: this.actions ? '' : 'd-none',
                    tdClass: this.actions ? '' : 'd-none'
                }
            ],
            filtering: false,
            loadingMore: false,
            filters: {
                request_date: this.settedFilters.request_date || {
                    startDate: null,
                    endDate: null
                },
                name_product: this.settedFilters.name_product || '',
                gross_amount: this.settedFilters.gross_amount || false,
                interveners: this.settedFilters.interveners || ''
            },
            timeOutFilter: null,
            timeOutFilterTime: 1500,
            localeDateRange: {
                direction: 'ltr',
                format: 'dd/mm/yyyy',
                separator: ' - ',
                daysOfWeek: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
                monthNames: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                firstDay: 1
            },
            rangeOpened: false,
            datepickerRequestDate: '',
            finalData: []
        };
    },

    mounted() {
        this.finalData = this.data;
        if (this.sortable) {
            this.$refs['operations-table'].$el.addEventListener('scroll', this.onScroll);
            if (this.scrollTop) {
                this.$refs['operations-table'].$el.scrollTop = this.scrollTop;
            }
        }

        this.$root.$on('get_operations_suggested', this.setFiltering);
        this.$root.$on('set_filtering_operations', this.setFiltering);
    },

    watch: {
        datepickerRequestDate(val) {
            this.filters['request_date'].startDate = val[0];
            this.filters['request_date'].endDate = val[1];
            this.changeColumnFilter('request_date');
        }
    },

    methods: {
        emitOperationToResume(item) {
            const { reconciliation } = item;
            const { isChecked } = this.$refs[`checkbox__op__${item.uuid}`];
            const searchBy = this.$store.getters['conciliationStore/searchBy'];

            if (reconciliation && (reconciliation.status === 'AGRUPADO' || reconciliation.status === 'PRECONCILIADO' || reconciliation.status === 'CONCILIADO')) {

                if (reconciliation.status === 'CONCILIADO') {
                    this.$store.dispatch('conciliationStore/disableAll', true);
                }

                this.$store.dispatch('conciliationStore/disableGroups', true);

                this.$root.$emit('set_filtering_transfers');
                if (isChecked) {
                    // Deseleccionar todos los demás
                    this.$store.dispatch('conciliationStore/removeTransfersSelected');
                    this.$store.dispatch('conciliationStore/removeOperationsSelected');
                    this.$paymentsService
                        .getReconciliationInfo(item.uuid_reconciliation)
                        .then(res => {

                            this.$store.dispatch('conciliationStore/setComment', res.data.reconciliation.comment);
                            this.autoSelectElements(res.data.reconciliation);
                            if (this.monitorType === 'historic' || reconciliation.status === 'CONCILIADO') {
                                const { transactions } = res.data.reconciliation;
                                transactions.map(transfer => {
                                    transfer.reconciliation = {};
                                    transfer.reconciliation.uuid = res.data.reconciliation.uuid;
                                    transfer.reconciliation.comment = res.data.reconciliation.comment;
                                    transfer.reconciliation.status = res.data.reconciliation.status;
                                    return transfer;
                                });
                                this.$root.$emit('set_transfers', transactions);
                            } else if (!searchBy || searchBy === 'transactions') {
                                this.getSuggestions();
                            }
                        })
                        .catch(err => console.error(err));
                } else {
                    this.operationToStore(item, 'remove');
                    const operationsList = this.$store.getters['conciliationStore/operations'];
                    if (!operationsList.length && searchBy === 'operations') {
                        this.$root.$emit('filter_transactions', 'all');
                        this.$store.dispatch('conciliationStore/setSuggestions', false);
                        this.$store.dispatch('conciliationStore/setSearchBy', false);
                    } else if (!searchBy || searchBy === 'operations') {
                        this.getSuggestions();
                    }
                }
            } else {
                // No agrupado
                this.$store.dispatch('conciliationStore/disableGroups', true);
                this.operationToStore(item, isChecked ? 'add' : 'remove');

                if (isChecked) {
                    if (!searchBy || searchBy === 'operations') {
                        this.getSuggestions();
                    }
                } else {
                    const operationsList = this.$store.getters['conciliationStore/operations'];
                    if (!operationsList.length && searchBy === 'operations') {
                        this.$store.dispatch('conciliationStore/disableGroups', false);
                        this.$store.dispatch('conciliationStore/disableAll', false);
                        this.$root.$emit('set_filtering_transfers');
                        this.$root.$emit('filter_transactions', 'all');
                        this.$store.dispatch('conciliationStore/setSuggestions', false);
                        this.$store.dispatch('conciliationStore/setSearchBy', false);
                    } else if (!searchBy || searchBy === 'operations') {
                        this.getSuggestions();
                    }
                }
            }

            if (isChecked) {
                this.$root.$emit('height_resume', 80);
                if (!searchBy) {
                    this.$store.dispatch('conciliationStore/setSearchBy', 'operations');
                }
            }
        },

        getSuggestions() {
            this.$root.$emit('set_filtering_transfers');
            this.$root.$emit('get_transfers_suggested');
        },

        /**
         * @override
         */
        isActive(item, type) {
            const index = _.findIndex(this.operationSelected, item);
            if (type === 'row-details') {
                return 'bg-greybody';
            }
            if (!item || type !== 'row') {
                return false;
            }
            if (index >= 0) {
                return 'table-success';
            }
            return '';
        },

        isDisabled(item) {
            const disableChecks = this.$store.getters['conciliationStore/disableGroups'];
            const disableAll = this.$store.getters['conciliationStore/disableAll'];
            return (item.reconciliation && disableChecks) || disableAll ? true : false;
        },

        removeOperation(item) {
            this.$store.dispatch('conciliationStore/removeOperation', item);
            const operationsList = this.$store.getters['conciliationStore/operations'];
            const transactionsList = this.$store.getters['conciliationStore/transfers'];
            if (!transactionsList.length && !operationsList.length) {
                this.$store.dispatch('conciliationStore/setSuggestions', false);
                this.$store.dispatch('conciliationStore/setSearchBy', false);
                this.$root.$emit('set_filtering_operations');
                this.$root.$emit('set_filtering_transfers');
                this.clearSelection();
            }
        },

        bankAccounts(accounts) {
            return accounts.map(x => x.iban_code);
        },

        holders(interveners) {
            if (interveners) {
                return interveners
                    .filter(
                        x =>
                            x.account_roles.includes('TITULAR') || x.account_roles.includes('NUDO_PROPIETARIO')
                    )
                    .map(x => {
                        return { item: x, name: `${x.name || ''} ${x.lastname_1 || ''} ${x.lastname_2 || ''}` };
                    });

            } else {
                return [];
            }
        },

        interveners(interveners) {
            return interveners.map(x => {
                return { item: x, name: `${x.name || ''} ${x.lastname_1 || ''} ${x.lastname_2 || ''}` };
            });
        },

        sortingChanged(state) {
            if (state.sortBy) {
                this.filtering = true;
                this.$root.$emit('filter_operations', false, state);
            }
        },

        onScroll(event) {
            if (event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight - 20
                && (this.data.metadata && this.data.metadata.paging._links._next.href)
                && !this.loadingMore) {

                this.loadingMore = true;
                this.$root.$emit('more_operations', this.data.metadata.paging._links._next.href, event.target.scrollTop);
            }
        },

        setFiltering() {
            this.filtering = true;
        },

        changeColumnFilter(filter) {
            if (this.suggestions) {
                // Si hay sugeridas, filtramos localmente
                this.localFilter(filter);
            } else {
                // Sino, filtro en BBDD
                clearTimeout(this.timeOutFilter);
                let timeOutFilter = this.timeOutFilterTime;
                if (filter === 'request_date' || filter === 'gross_amount') {
                    timeOutFilter = 0;
                }
                this.timeOutFilter = setTimeout(() => {
                    this.filtering = true;
                    this.$root.$emit('filter_columns_operations', this.filters);
                }, timeOutFilter);
            }
        },

        seeSuggestions() {
            this.$root.$emit('get_operations_suggested');
        },

        clearColumnFilter(filter) {
            if (filter === 'request_date') {
                this.filters[filter] = {
                    startDate: null,
                    endDate: null
                };
            } else {
                this.filters[filter] = false;
            }
            this.filtering = true;
            this.$root.$emit('filter_columns_operations', this.filters);
        },

        toggleRange() {
            this.rangeOpened = !this.rangeOpened;
            if (!this.filters['gross_amount']) {
                this.filters['gross_amount'] = [this.minAmount, this.maxAmount];
            }
        },

        localFilter(filter) {
            this.filtering = true;
            this.finalData = [];
            this.finalData = this.data.filter(item => {
                if (filter === 'request_date') {
                    if (this.filters[filter].endDate && this.filters[filter].startDate) {
                        return this.$moment(item.request_date) >= this.$moment(this.filters[filter].startDate) &&
                            this.$moment(item.request_date) <= this.$moment(this.filters[filter].endDate).add(1, 'day');
                    } else {
                        return item;
                    }
                } else if (filter === 'gross_amount') {
                    return +item.gross_amount >= this.filters[filter][0] &&
                        +item.gross_amount <= this.filters[filter][1];
                } else if (filter === 'name_product') {
                    return item.name_product.toLowerCase().includes(this.filters[filter].toLowerCase());
                } else if (filter === 'interveners') {
                    const holders = this.holders(item.interveners);
                    const findHolder = holders.find(holder => {
                        return holder.name.toLowerCase().includes(this.filters[filter].toLowerCase())
                            || holder.item.document_id.toLowerCase().includes(this.filters[filter].toLowerCase());
                    });
                    if (findHolder) {
                        return item;
                    } else {
                        return false;
                    }
                } else {
                    return item;
                }
            });
            this.rangeOpened = false;
            this.filtering = false;
        },

        changeFilter(filter) {
            this.filtering = true;
            // this.clearSelection(true);
            // this.$root.$emit('filter_transactions', filter);
            this.$root.$emit('filter_operations', filter);
            this.clearColumnFilter('all');
            this.$store.dispatch('conciliationStore/setSuggestions', false);
        }
    },

    computed: {
        operationsAmmount() {
            let total = 0;
            this.data.forEach(item => {
                total += +item.gross_amount;
            });
            return total;
        },

        seleccionadosOp: {
            get() {
                const items = this.$store.getters['conciliationStore/operations'];
                const actives = items.map(x => x.uuid);
                return actives;
            },
            set(newName) {
                return newName;
            }
        },
        suggestions() {
            return this.$store.getters['conciliationStore/suggestions'];
        },
        searchBy() {
            return this.$store.getters['conciliationStore/searchBy'];
        }
    },

    /**
     * @override
     */
    beforeDestroy() {
        this.$root.$off('get_operations_suggested', this.setFiltering);
        this.$root.$off('set_filtering_operations', this.setFiltering);
        // this.$root.$off('clear_all_conciliation', this.setFiltering);
    }
};
